<template>
  <div>
    <Table :columns="columns" :data="planSales" :is-row-clickable="true" @row-click="redirectToDetails">
      <template #contract="{ row }">
        <div class="flex flex-col">
          <span class="font-semibold">{{ row.title }}</span>
          <span class="font-medium">{{ contractPrice(row) }}</span>
          <span class="font-light">{{ row.category }}</span>
          <span class="font-light">{{ row.id }} - {{ row.purchaseDate }}</span>
          <span v-if="isCancelled(row)" class="font-light italic">
            {{ t("cancelled_on", { date: row.cancellation?.date }) }}
          </span>
        </div>
      </template>

      <template #product="{ row }">
        <div v-if="row.products?.length > 0">
          <span class="font-semibold">{{ row.products[0].title }}</span>
          <div class="flex">
            <span class="font-light italic mr-2">{{ formatPrice(row.products[0].price) }}</span>
          </div>
        </div>
        <span v-else>-</span>
        <span>{{ row.store?.salesChannel }}</span>
      </template>

      <template #customer="{ row }">
        <div class="flex flex-col">
          <span class="font-semibold">{{ row.customer.firstName }} {{ row.customer.lastName }}</span>
          <span>{{ row.customer.email }}</span>
        </div>
      </template>

      <template #status="{ row }">
        <FieldSpan :value="row.status" :style-to-add="statusListStyle(row)" translation-prefix="planSale.status" />
      </template>
    </Table>

    <Pagination
      :currentPage="currentPage"
      :totalPages="totalPages"
      :totalCount="totalCount"
      @changePage="handleChangePage"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { useI18n } from "vue-i18n";
import { FieldSpan, Pagination, Table, formatPrice } from "@estaly/ui";

export default {
  name: "PlanSaleTable",

  components: { FieldSpan, Pagination, Table },

  props: {
    planSales: {
      type: Array,
      required: true,
    },
    currentPage: {
      type: Number,
      required: true,
    },
    totalPages: {
      type: Number,
      required: true,
    },
    totalCount: {
      type: Number,
      required: true,
    },
  },

  emits: ["update-page"],

  setup() {
    const { t } = useI18n();
    return { t };
  },

  computed: {
    ...mapGetters("planSales", ["isCancelled", "statusListStyle"]),

    columns() {
      return [
        { label: this.t("column_contract"), field: "price", slot: "contract" },
        { label: this.t("column_product"), field: "product", slot: "product" },
        { label: this.t("column_customer"), field: "customer", slot: "customer" },
        { label: this.t("column_status"), field: "status", slot: "status" },
      ];
    },
  },

  methods: {
    formatPrice,

    contractPrice(planSale) {
      const price = formatPrice(planSale.price);
      return planSale.monthly ? this.t("price_per_month", { price }) : price;
    },

    handleChangePage(page) {
      this.$emit("update-page", page);
    },

    redirectToDetails(planSale) {
      this.$router.push(`/plan-sales/${planSale.friendlyId}`);
    },
  },
};
</script>

<i18n src="./PlanSaleTable.i18n.json"></i18n>
